// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2_yzC","inner":"style_inner__hdkgh","bottom":"style_bottom__24I-q","copyright":"style_copyright__3oWl3"};